module.exports = __webpack_public_path__ + "static/img/6525b5b.063315df.png";